import { render, staticRenderFns } from "./dealSaleRewardDialog.vue?vue&type=template&id=d8ec9f64&scoped=true"
import script from "./dealSaleRewardDialog.vue?vue&type=script&lang=js"
export * from "./dealSaleRewardDialog.vue?vue&type=script&lang=js"
import style0 from "./dealSaleRewardDialog.vue?vue&type=style&index=0&id=d8ec9f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ec9f64",
  null
  
)

export default component.exports